import * as React from 'react';
import { IconButton } from '@openedx/paragon';
import { AutoGraph } from '@openedx/paragon/icons';
import { useAspectsSidebarContext } from '../hooks';
import { castToBlock } from '../types';
export function SubSectionAnalyticsButton(_ref) {
  let {
    subsection
  } = _ref;
  const {
    activeBlock,
    sidebarOpen,
    setActiveBlock,
    setSidebarOpen
  } = useAspectsSidebarContext();
  if (!subsection.graded) {
    return null;
  }
  return /*#__PURE__*/React.createElement(IconButton, {
    alt: "Analytics",
    iconAs: AutoGraph,
    isActive: sidebarOpen && activeBlock?.id === subsection.id,
    onClick: () => {
      setSidebarOpen(true);
      setActiveBlock(castToBlock(subsection));
    }
  });
}